import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export const FaqAccordion = ({ faqs, testPrefix = "faq" }) => (
  <Accordion type="single" collapsible className="divide-y divide-white/10 border-y border-white/10">
    {faqs.map((f, i) => (
      <AccordionItem key={i} value={`q-${i}`} className="border-0">
        <AccordionTrigger data-testid={`${testPrefix}-trigger-${i}`} className="text-left text-base font-medium text-slate-100 hover:text-[var(--blue)] hover:no-underline py-5">{f.q}</AccordionTrigger>
        <AccordionContent data-testid={`${testPrefix}-content-${i}`} className="text-sm text-slate-400 leading-relaxed pb-5">{f.a}</AccordionContent>
      </AccordionItem>
    ))}
  </Accordion>
);
